export enum FeatureFlag {
  BankIdV6 = 'useBankidV6',
}
